webpackJsonp([427],{

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(2018),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/issue-144.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] issue-144.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09502025", Component.options)
  } else {
    hotAPI.reload("data-v-09502025", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2018:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("如何提 issue")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("使用本项目意味着你也有义务帮助其变得更好。")])]), _vm._v(" "), _c('p', [_vm._v("不要浪费维护者时间。")]), _vm._v(" "), _c('p', [_vm._v("不要让维护者帮你学习"), _c('code', [_vm._v("Vue")]), _vm._v("，帮你熟悉"), _c('code', [_vm._v("vue-loader")]), _vm._v("，甚至帮你写代码。")]), _vm._v(" "), _c('p', [_vm._v("不要认为随便一句话就能让维护者明白你的意思，我们没有你想象的那么厉害。")]), _vm._v(" "), _c('p', [_vm._v("不要提没有任何意义的、代码中带有业务逻辑不方便重现的Issue。")]), _vm._v(" "), _c('p', [_vm._v("直接关闭你的"), _c('code', [_vm._v("issue")]), _vm._v("不是对你不满，是你提问题方式不对，没有必要再浪费时间说明为什么要关闭你的"), _c('code', [_vm._v("issue")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("马虎的提问，缺少上下文和重现步骤是在浪费彼此时间。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09502025", module.exports)
  }
}

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1743);

/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "如何提 issue | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 427.a592fccd.js